module.exports = __webpack_public_path__ + "img/DavidHarp.494ec461.jpg";